import { fetchAndSanitizeSchema } from '~/utils/rjsfValidator';

import { json_headers, request } from './common';

export default class PackagesService {
  static basePath(idOffer) {
    return `${window.configs.API_HOST}/api/offers/${idOffer}/packages`;
  }

  static getPackageSchema(idOffer) {
    return fetchAndSanitizeSchema(this.basePath(idOffer));
  }

  // Unlike updatePackage, idPackage must be the package uuid (`le_package_id`); the Salesforce id is rejected.
  static updatePackageStatus(status: string, idOffer: string, idPackage: string) {
    return request(`${this.basePath(idOffer)}/${idPackage}/status`, {
      method: 'PATCH',
      headers: json_headers,
      body: JSON.stringify({ status }),
    });
  }

  static updatePackage(object, idOffer, idPackage) {
    const jsonData = JSON.stringify(object);
    return request(this.basePath(idOffer) + '/' + idPackage, {
      method: 'PATCH',
      headers: json_headers,
      body: jsonData,
    });
  }
}
